import React from "react";
import PropTypes from "prop-types";
const CartIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M-4-4h24v24H-4z" />
      <g>
        <rect
          width="13.557"
          height="2"
          fill={color || "var(--color-easil-gray-x-dark)"}
          rx="1"
        />
        <path
          fill={color || "var(--color-easil-gray-x-dark)"}
          d="M2 0h2v11H2z"
        />
        <rect
          width="10"
          height="2"
          x="2"
          y="10"
          fill={color || "var(--color-easil-gray-x-dark)"}
          rx="1"
        />
        <circle
          cx="3.5"
          cy="14.5"
          r="1.5"
          fill={color || "var(--color-easil-gray-x-dark)"}
        />
        <circle
          cx="10.5"
          cy="14.5"
          r="1.5"
          fill={color || "var(--color-easil-gray-x-dark)"}
        />
        <path
          stroke={color || "var(--color-easil-gray-x-dark)"}
          strokeWidth="2"
          d="M3 7h9.438a1 1 0 0 0 .97-.757L14.72 1H3v6z"
        />
      </g>
    </g>
  </svg>
);
CartIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default CartIcon;
